import { ThunkAction } from "redux-thunk"
import { StoreState } from "../StoreState"
import { AnyAction } from "redux"
import { HttpMethod } from "../../type/request/HttpMethod"
import { requestThunk } from "./serverThunks"
import { configurationReducerActions, EEnvironment } from "../reducers/configurationReducer"

export const initializeThunk = (): ThunkAction<void, StoreState, null, AnyAction> => async (dispatch, getState) => {
    const res = await dispatch(requestThunk<{ environment: EEnvironment }>(HttpMethod.GET, "configuration"))
    dispatch(configurationReducerActions.setEnvironment(res.environment))
}
